module.exports = __webpack_public_path__ + "media/stylesheets/images/rulers-0feec21668fd17d507c1a7bc87e89be1.png";